import { UserPlus } from "lucide-react";
import { useRecordContext } from "ra-core";
import { Link } from "react-router";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { Edit } from "@/components/admin/edit";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { SimpleForm } from "@/components/admin/simple-form";
import { TextInput } from "@/components/admin/text-input";
import { Button } from "@/components/ui/button";
import { AutocompleteCompanyInput } from "../companies/AutocompleteCompanyInput";
import { contactOptionText } from "../misc/ContactOption";

const CreateContactFromEmail = () => {
  const record = useRecordContext<{ sender_email?: string }>();
  if (!record?.sender_email) return null;
  return (
    <Button asChild type="button" variant="outline">
      <Link
        to="/contacts/create"
        state={{
          record: {
            email_jsonb: [{ email: record.sender_email, type: "Work" }],
            source: "email",
          },
        }}
      >
        <UserPlus className="size-4" />
        Crear contacto con este correo
      </Link>
    </Button>
  );
};

export const EmailEdit = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="sender_email" disabled helperText={false} />
      <TextInput source="subject" disabled helperText={false} />
      <TextInput
        source="snippet"
        disabled
        multiline
        rows={4}
        helperText={false}
      />
      <SelectInput
        source="status"
        choices={[
          { id: "associated", name: "Asociado" },
          { id: "review", name: "Requiere revisión" },
          { id: "ignored", name: "Ignorado" },
        ]}
        helperText={false}
      />
      <ReferenceInput source="company_id" reference="companies">
        <AutocompleteCompanyInput label="Empresa" />
      </ReferenceInput>
      <ReferenceInput source="contact_id" reference="contacts_summary">
        <AutocompleteInput optionText={contactOptionText} helperText={false} />
      </ReferenceInput>
      <ReferenceInput source="deal_id" reference="deals">
        <AutocompleteInput optionText="name" helperText={false} />
      </ReferenceInput>
      <CreateContactFromEmail />
    </SimpleForm>
  </Edit>
);
